import React, { useContext } from 'react'
// import { useNavigate } from 'react-router-dom'
import { Button, Image, DropdownButton } from 'react-bootstrap'
import { AuthContext } from './ContextProvider'

function HeaderAccount() {
  // const navigate = useNavigate()
  // const { setToast } = useContext(ToastContext)
  const { auth, logout } = useContext(AuthContext)
  const { Email = '', Name = '' } = auth

  // const loginOut = async () => {
  //   setToast({ show: true, text: '已登出' })
  //   logout()
  // }

  return (
    <DropdownButton
      id="dropdown-button-drop-end"
      align="start"
      title={
        <div id="accountHeader" className="account">
          <div className="account-avatar">{Name[0]}</div>
          <span>{Name}</span>
        </div>
      }
    >
      <div className="account-card toggle-wrap shadow-block">
        <div className="form-group d-flex flex-wrap">
          <div className="avatar-icon d-flex w-25">
            <Image
              src="/images/svgicons/account.svg"
              alt=""
              className="h-75 my-auto"
            />
          </div>
          <div className="account-name fs-5 w-75">
            帳號名稱
            <br />
            {Email}
          </div>
        </div>
        <ul>
          <li>
            <a href="/dashboard" className="primary-link">
              Dashboard
            </a>
          </li>
          <li>
            <Button className="btn-text" onClick={() => logout()}>
              登出
            </Button>
          </li>
        </ul>
      </div>
    </DropdownButton>
  )
}

export default HeaderAccount
